import { PRESETS, matchPreset, today } from '../lib/dateRange.js';

/* From–To with quick presets.

   The date fields are native <input type="date">, so the browser supplies a
   real calendar and keyboard entry for free — no date library, which keeps the
   bundle small and sidesteps the artifact CSP entirely.

   Future dates are barred (max = today): there are no calls yet to come. The
   two inputs also fence each other — you can't set From after To — so the
   range is always sane before it reaches the backend. */
export default function DateRangePicker({ range, onChange }) {
  const active = matchPreset(range);
  const todayStr = today();

  const setFrom = (from) => onChange({ from, to: range.to < from ? from : range.to });
  const setTo = (to) => onChange({ from: range.from > to ? to : range.from, to });

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {PRESETS.map((p) => (
          <button
            key={p.key}
            type="button"
            className="btn btn--filter"
            aria-pressed={active === p.key}
            onClick={() => onChange(p.range())}
          >
            {p.label}
          </button>
        ))}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <label style={labelStyle}>
          <span style={captionStyle}>From</span>
          <input
            type="date"
            className="date-input"
            value={range.from}
            max={range.to || todayStr}
            onChange={(e) => e.target.value && setFrom(e.target.value)}
          />
        </label>
        <label style={labelStyle}>
          <span style={captionStyle}>To</span>
          <input
            type="date"
            className="date-input"
            value={range.to}
            min={range.from}
            max={todayStr}
            onChange={(e) => e.target.value && setTo(e.target.value)}
          />
        </label>
      </div>
    </div>
  );
}

const labelStyle = { display: 'flex', alignItems: 'center', gap: 6 };
const captionStyle = {
  fontFamily: 'var(--font-mono)',
  fontSize: 11,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  color: 'var(--ink-soft)',
};
